import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M10.414 12l5.293-5.293c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0l-6 6c-.39.39-.39 1.024 0 1.414l6 6c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414L10.414 12z",
		transform: "translate(-719 -248) translate(384 120) translate(72 128) translate(263)"
	})
});
export default SvgChevronLeft;
